import { Avatar, desktopFirstMediaQuery } from '@inflearn/ds-react-next';

export function AvatarImage({ src }: { src: string }) {
  return (
    <Avatar
      radius="50%"
      alt="profile image"
      src={src}
      styles={{
        root: {
          '--avatar-size': '90px',
          [desktopFirstMediaQuery.mobile]: {
            '--avatar-size': '72px',
          },
        },
      }}
    />
  );
}
